import React, { Component } from 'react';
import { Box, Paper } from '@mui/material';
import { FormattedMessage, injectIntl } from 'react-intl';
import { IntlState } from 'react-intl-redux';
import { styled } from '@mui/material/styles';
import TrialDetailsList from './TrialDetailsList';
import { Enrollment, Submission, Trial } from '../../redux/types';
import GenericDialog from '../GenericDialog';
import AGB from '../AGB';

const LinkButton = styled('button')(({ theme }) => `
background-color: transparent;
color: ${theme.palette.primary.main};
border: none;
cursor: pointer;
text-decoration: underline;
display: inline;
margin: 0;
padding: 0;
`);

type Props = {
  trial: Trial;
  renderAdditionalRows: (trial: Trial) => ('' | JSX.Element | undefined)[];
  enrollment?: Enrollment & {
    submission?: Submission;
  };
  intl: IntlState;
  renderTrialDetails?: boolean;
  renderTrialActions: (obj: Trial & { enrollment?: Enrollment }) => React.ReactNode;
}

type State = {
  showCostDetail: boolean;
};
class TrialDetails extends Component<Props, State> {
  // eslint-disable-next-line react/static-property-placement
  public static defaultProps = {
    renderTrialDetails: true,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      showCostDetail: false,
    };
  }

  renderDetails = () => {
    const {
      trial,
      renderAdditionalRows,
      enrollment,
      intl,
    } = this.props;

    const newEnrollmentDate = enrollment?.allowPostResubmit ? enrollment?.extendedSubmissionDate : '';
    const rows = [
      [
        <span key="span1">
          {`${intl.messages['trials.registrationStartDate']}: ${new Date(trial.registrationStartDate).toLocaleDateString('DE')}`}
        </span>,
        <span key="span2">
          {`${intl.messages['trials.registrationEndDate']}: ${new Date(trial.registrationEndDate).toLocaleDateString('DE')}`}
        </span>,
      ],
      [
        <span key="span3">
          {`${intl.messages['trials.startDate']}: ${new Date(trial.startDate).toLocaleDateString('DE')}`}
        </span>,
        <span key="span4">
          {`${intl.messages['trials.endDate']}: ${new Date(trial.endDate).toLocaleDateString('DE')}`}
        </span>,
      ],
      [
        <span key="span5">
          {`${intl.messages['trials.numSamples']}: ${trial.samples}`}
        </span>,
        <span key="span6">
          {`${intl.messages['trials.price']}: ${trial.priceInEUR}€ `}
          <LinkButton onClick={() => this.setState({ showCostDetail: true })}>
            <FormattedMessage id="trialdetails.pricedescription" />
          </LinkButton>
        </span>,
      ],
      [
        trial.participants !== -1
          ? (
            <span>
              {`${intl.messages['trials.numParticipants']}: ${trial.enrollments || '0'}/${trial.participants}`}
            </span>
          ) : <span />,
        newEnrollmentDate
        && (
          <span key="span8" style={{ color: 'orange' }}>
            {`${intl.messages['trials.newPostSubmissionDate']}: ${new Date(newEnrollmentDate).toLocaleDateString('DE')}`}
          </span>
        ),
      ],
    ];
    return (
      <TrialDetailsList
        rows={renderAdditionalRows
          ? rows.concat(renderAdditionalRows(trial))
          : rows}
      />
    );
  };

  render() {
    const {
      renderTrialDetails,
      renderTrialActions,
      enrollment,
      intl,
    } = this.props;
    const { showCostDetail } = this.state;
    if (!renderTrialActions && !renderTrialDetails) {
      return false;
    }
    const { trial } = this.props;
    let newTrialObj: Trial & { enrollment?: Enrollment } = { ...trial };
    if (enrollment) {
      newTrialObj = {
        ...newTrialObj,
        enrollment,
      };
    }
    return (
      <>
        <Paper className="pa3" elevation={0}>
          {renderTrialDetails && this.renderDetails()}
          {renderTrialActions(newTrialObj)}
        </Paper>
        <GenericDialog
          isOpen={showCostDetail}
          onRequestClose={() => this.setState({ showCostDetail: false })}
        >
          <Box sx={{ p: 3 }}>
            <AGB locale={intl.locale} scrollTo="shipping" />
          </Box>
        </GenericDialog>
      </>
    );
  }
}

export default injectIntl(TrialDetails);
